import React, { useState } from "react";
import "./Collapse.scss";
import Text from "../../Atomsv2/Text/Text";

const Collapse = ({ icon, iconElement, title, children, defaultOpen = true, className = "", height }) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className={`Collapse ${open ? "is-open" : ""} ${className}`}>
            <button
                className="collapse-header"
                onClick={() => setOpen(prev => !prev)}
                aria-expanded={open}
                type="button"
            >
                <div className="collapse-title-group">
                    {iconElement
                        ? iconElement
                        : icon && <span className="icon collapse-icon" data-icon={icon} />}
                    <Text weight={700} color={'var(--text-primary)'} className="collapse-title">{title}</Text>
                </div>
                <span
                    className="icon collapse-chevron"
                    data-icon="expand_more"
                    aria-hidden="true"
                />
            </button>

            <div className="collapse-body" aria-hidden={!open}>
                <div className="collapse-inner">
                    <div
                        className="collapse-scroll"
                        style={height ? { maxHeight: height, overflowY: 'auto' } : undefined}
                    >
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Collapse;
